import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { environment } from "@env";
@Component({
  selector: "app-profile-main",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent {
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  user: string | null = "";
  async ngOnInit() {
    const userInfo = await this.keycloakService.loadUserProfile();
    this.user = userInfo?.username || null;
  }

  
// async logout() {
//   try {
//     const kc = this.keycloakservice.getKeycloakInstance();
//     const idToken = kc.idToken;

//     if (idToken) {
//       // Method 1: Use id_token_hint if available
//       const logoutUrl =
//         kc.authServerUrl +
//         '/realms/' +
//         kc.realm +
//         '/protocol/openid-connect/logout' +
//         '?id_token_hint=' +
//         encodeURIComponent(idToken) +
//         '&post_logout_redirect_uri=' +
//         encodeURIComponent(window.location.origin + '/products');
      
//       window.location.href = logoutUrl;
//     } else {
//       // Method 2: Fallback to service logout
//       console.warn('idToken not available, using service logout');
//       await this.keycloakservice.logout(window.location.origin );
//     }
//   } catch (error) {
//     console.error('Logout error:', error);
//     // Final fallback
//     await this.keycloakservice.logout(window.location.origin + '/products');
//   }
// }

 async logout(): Promise<void> {

    try {

      // Refresh token before logout
      try {
        await this.keycloakService.updateToken(30);
      } catch (refreshError) {
        console.warn(
          'Token refresh failed before logout',
          refreshError
        );
      }

      const kc =
        this.keycloakService.getKeycloakInstance();

      // Prevent invalid id_token_hint=undefined
      if (!kc.idToken) {

        console.warn(
          'No idToken available. Redirecting manually.'
        );

        window.location.href = window.location.origin;

        return;
      }

      await this.keycloakService.logout(
        window.location.origin
      );

    } catch (error) {

      console.error('Logout failed', error);

      window.location.href = window.location.origin;
    }
  }


  back() {
    this.router.navigate(["products"]);
  }
}